import React, { useEffect } from "react";
import { Button, Modal } from "antd";
import { toast } from "react-toastify";
import { updateOrder } from "../api";
import styles from "../styles/modals.module.css";

const LogisticsModal = ({
  visible,
  orderData,
  logisticsForm,
  submitting,
  onClose,
  onFormChange,
  onSuccess,
  setSubmitting,
  isEditing = false,
}) => {
  // Populate form with existing data when editing
  useEffect(() => {
    if (visible && isEditing && orderData?.logisticPartnerDetails) {
      const details = orderData.logisticPartnerDetails;
      onFormChange('logisticsPartner', details.logisticsPartner || '');
      onFormChange('link', details.link || '');
      onFormChange('invoiceNo', details.invoiceNo || '');
      onFormChange('amount', details.amount || '');
      onFormChange('awb', details.awb || '');
      onFormChange('dispatchDate', details.dispatchDate ? details.dispatchDate.split('T')[0] : '');
      onFormChange('expectedDeliveryDate', details.expectedDeliveryDate ? details.expectedDeliveryDate.split('T')[0] : '');
    }
  }, [visible, isEditing, orderData]);

  const handleLogisticsSubmit = async () => {
    if (!logisticsForm.logisticsPartner.trim()) {
      toast.error('Logistics Partner is required');
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        logisticPartnerDetails: {
          logisticsPartner: logisticsForm.logisticsPartner,
          link: logisticsForm.link,
          invoiceNo: logisticsForm.invoiceNo,
          amount: logisticsForm.amount,
          awb: logisticsForm.awb,
          dispatchDate: logisticsForm.dispatchDate,
          expectedDeliveryDate: logisticsForm.expectedDeliveryDate
        }
      };

      await updateOrder(orderData?._id, payload);

      toast.success(isEditing ? 'Logistics details updated successfully' : 'Logistics partner assigned successfully');
      onSuccess();
    } catch (error) {
      toast.error(isEditing ? 'Failed to update logistics details' : 'Failed to assign logistics partner');
      console.error('Error updating logistics:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={isEditing ? "Edit Logistics Details" : "Assign Logistics Partner"}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>
            Logistics Partner<span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            className={styles.formControl}
            placeholder="Logistics Partner"
            value={logisticsForm.logisticsPartner}
            onChange={(e) => onFormChange('logisticsPartner', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Link</label>
          <input
            type="text"
            className={styles.formControl}
            placeholder="Link"
            value={logisticsForm.link}
            onChange={(e) => onFormChange('link', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Invoice No</label>
          <input
            type="text"
            className={styles.formControl}
            placeholder="Invoice Number"
            value={logisticsForm.invoiceNo}
            onChange={(e) => onFormChange('invoiceNo', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Amount</label>
          <input
            type="text"
            className={styles.formControl}
            placeholder="Amount"
            value={logisticsForm.amount}
            onChange={(e) => onFormChange('amount', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>AWB</label>
          <input
            type="text"
            className={styles.formControl}
            placeholder="AWB"
            value={logisticsForm.awb}
            onChange={(e) => onFormChange('awb', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Dispatch Date</label>
          <input
            type="date"
            className={styles.formControl}
            placeholder="Dispatch Date"
            value={logisticsForm.dispatchDate}
            onChange={(e) => onFormChange('dispatchDate', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Expected Delivery Date</label>
          <input
            type="date"
            className={styles.formControl}
            placeholder="Expected Delivery Date"
            value={logisticsForm.expectedDeliveryDate}
            onChange={(e) => onFormChange('expectedDeliveryDate', e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className={styles.buttonGroup}>
          <Button
            onClick={onClose}
            disabled={submitting}
            className={styles.cancelButton}
          >
            Close
          </Button>
          <Button
            type="primary"
            onClick={handleLogisticsSubmit}
            loading={submitting}
            className={styles.submitButton}
            disabled={!logisticsForm.logisticsPartner.trim() || submitting}
          >
            {isEditing ? 'Update' : 'Submit'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LogisticsModal; 